$(document).ready(function () {
    if (!window.gsap || !window.ScrollTrigger) {
        return;
    }

    gsap.registerPlugin(ScrollTrigger);

    var pinEl = document.querySelector('#UT3_2026 .module2 .gasp-box');
    var overflowEl = document.querySelector('#UT3_2026 .module2 .overflow-box');
    var collectionEl = document.querySelector('#UT3_2026 .module2 .SP-collection');

    var isPcLayout = window.matchMedia ? window.matchMedia('(min-width: 1081px)').matches : (window.innerWidth > 1080);

    if (isPcLayout && pinEl && overflowEl && collectionEl) {
        var getScrollDistance = function () {
            var total = collectionEl.scrollWidth;
            var visible = overflowEl.clientWidth;
            return Math.max(0, total - visible);
        };

        var initHorizontalScroll = function () {
            var distance = getScrollDistance();
            var existing = ScrollTrigger.getById('ut3-module2-horizontal');
            if (existing) {
                existing.kill(true);
            }

            if (!distance) {
                gsap.set(collectionEl, { x: 0 });
                return;
            }

            gsap.to(collectionEl, {
                x: -distance,
                ease: 'none',
                scrollTrigger: {
                    id: 'ut3-module2-horizontal',
                    trigger: pinEl,
                    start: 'top 110px',
                    end: '+=' + distance,
                    pin: true,
                    scrub: true,
                    anticipatePin: 1,
                    invalidateOnRefresh: true
                }
            });
        };

        initHorizontalScroll();
    } else {
        var existingPcScroll = ScrollTrigger.getById('ut3-module2-horizontal');
        if (existingPcScroll) {
            existingPcScroll.kill(true);
        }
        if (collectionEl) {
            gsap.set(collectionEl, { x: 0 });
        }
    }

    var setupScrollTriggerToggleClass = function (id, triggerSelector, start, activeClassName) {
        var triggerEl = typeof triggerSelector === 'string' ? document.querySelector(triggerSelector) : triggerSelector;
        if (!triggerEl) {
            return;
        }

        var existing = ScrollTrigger.getById(id);
        if (existing) {
            existing.kill(true);
        }

        var className = activeClassName || 'is-active';
        ScrollTrigger.create({
            id: id,
            trigger: triggerEl,
            start: start || 'top 50%',
            onEnter: function () {
                triggerEl.classList.add(className);
            },
            onLeaveBack: function () {
                triggerEl.classList.remove(className);
            },
            invalidateOnRefresh: true
        });

        var images = triggerEl.querySelectorAll('img');
        for (var i = 0; i < images.length; i++) {
            images[i].addEventListener('load', function () {
                ScrollTrigger.refresh();
            });
        }

        if (window.MutationObserver) {
            var observer = new MutationObserver(function (mutations) {
                for (var j = 0; j < mutations.length; j++) {
                    if (mutations[j].type === 'attributes' && mutations[j].attributeName === 'src') {
                        ScrollTrigger.refresh();
                        return;
                    }
                }
            });

            for (var k = 0; k < images.length; k++) {
                observer.observe(images[k], { attributes: true, attributeFilter: ['src'] });
            }
        }
    };

    // setupScrollTriggerToggleClass('ut3-module10-pos-text', '#UT3_2026 .module10 .display-feature__bg', 'top 50%', 'is-active');
    // setupScrollTriggerToggleClass('ut3-module12-img-warpper2', '#UT3_2026 .module12 .display-feature__bg .img-warpper2', 'top 50%', 'is-active');

    var module2Sp3El = document.querySelector('#UT3_2026 .module2 .SP-collection .SP-3');
    var module2Sp3PosPEl = document.querySelector('#UT3_2026 .module2 .SP-collection .SP-3 .pos-text .pos-p');
    if (module2Sp3El && module2Sp3PosPEl) {
        var module2Sp3Threshold = 0.8;
        var module2Sp3IsActive = false;
        var module2Sp3Activate = function () {
            if (module2Sp3IsActive) {
                return;
            }
            module2Sp3IsActive = true;
            module2Sp3PosPEl.classList.add('is-active');
        };
        var module2Sp3Reset = function () {
            if (!module2Sp3IsActive) {
                return;
            }
            module2Sp3IsActive = false;
            module2Sp3PosPEl.classList.remove('is-active');
        };

        if (window.IntersectionObserver) {
            var module2Sp3Observer = new IntersectionObserver(
                function (entries) {
                    var entry = entries && entries.length ? entries[0] : null;
                    if (!entry) {
                        return;
                    }

                    if (!entry.isIntersecting || entry.intersectionRatio === 0) {
                        module2Sp3Reset();
                        return;
                    }

                    if (entry.intersectionRatio >= module2Sp3Threshold) {
                        module2Sp3Activate();
                    }
                },
                { threshold: [0, module2Sp3Threshold] }
            );
            module2Sp3Observer.observe(module2Sp3El);
        } else {
            var module2Sp3Ticking = false;
            var module2Sp3Check = function () {
                module2Sp3Ticking = false;
                var rect = module2Sp3El.getBoundingClientRect();
                var viewH = window.innerHeight || document.documentElement.clientHeight;
                var visibleTop = Math.max(0, rect.top);
                var visibleBottom = Math.min(viewH, rect.bottom);
                var visibleHeight = Math.max(0, visibleBottom - visibleTop);
                var ratio = rect.height ? visibleHeight / rect.height : 0;
                if (ratio <= 0) {
                    module2Sp3Reset();
                    return;
                }
                if (ratio >= module2Sp3Threshold) {
                    module2Sp3Activate();
                }
            };

            var module2Sp3OnScroll = function () {
                if (module2Sp3Ticking) {
                    return;
                }
                module2Sp3Ticking = true;
                requestAnimationFrame(module2Sp3Check);
            };

            window.addEventListener('scroll', module2Sp3OnScroll, { passive: true });
            window.addEventListener('resize', module2Sp3OnScroll);
            module2Sp3OnScroll();
        }
    }

    var setupDelayedVisibilityClass = function (triggerSelector, targetSelector, threshold, delayMs, activeClass, removeOnLeaveBackOnly) {
        var triggerEls = document.querySelectorAll(triggerSelector);
        if (!triggerEls || !triggerEls.length) {
            return;
        }

        var ratioThreshold = typeof threshold === 'number' ? threshold : 1;
        var delay = typeof delayMs === 'number' ? delayMs : 0;
        var activeClassName = activeClass || 'is-active';
        var removeOnlyOnScrollUp = !!removeOnLeaveBackOnly;
        var lastScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
        var getScrollDirection = function () {
            var y = window.pageYOffset || document.documentElement.scrollTop || 0;
            var dir = y < lastScrollY ? -1 : 1;
            lastScrollY = y;
            return dir;
        };

        for (var ti = 0; ti < triggerEls.length; ti++) {
            (function () {
                var triggerEl = triggerEls[ti];
                var targetEl = triggerEl.querySelector(targetSelector);
                if (!targetEl) {
                    return;
                }

                var timer = null;
                var setActive = function (shouldActivate) {
                    if (timer) {
                        clearTimeout(timer);
                        timer = null;
                    }

                    if (shouldActivate) {
                        var applyActive = function () {
                            targetEl.classList.add(activeClassName);
                            timer = null;
                        };

                        if (delay > 0) {
                            timer = setTimeout(applyActive, delay);
                        } else {
                            applyActive();
                        }
                        return;
                    }

                    targetEl.classList.remove(activeClassName);
                };

                if (window.IntersectionObserver) {
                    var observer = new IntersectionObserver(
                        function (entries) {
                            var dir = getScrollDirection();
                            for (var ei = 0; ei < entries.length; ei++) {
                                if (entries[ei].isIntersecting && entries[ei].intersectionRatio >= ratioThreshold) {
                                    setActive(true);
                                    return;
                                }
                            }
                            if (targetEl.classList.contains(activeClassName)) {
                                if (!removeOnlyOnScrollUp || dir === -1) {
                                    setActive(false);
                                }
                            }
                        },
                        { threshold: ratioThreshold }
                    );
                    observer.observe(triggerEl);
                    return;
                }

                ScrollTrigger.create({
                    trigger: triggerEl,
                    start: 'top bottom',
                    end: 'bottom top',
                    onUpdate: function (self) {
                        var rect = triggerEl.getBoundingClientRect();
                        var viewH = window.innerHeight || document.documentElement.clientHeight;
                        var visibleTop = Math.max(0, rect.top);
                        var visibleBottom = Math.min(viewH, rect.bottom);
                        var visibleHeight = Math.max(0, visibleBottom - visibleTop);
                        var ratio = rect.height ? visibleHeight / rect.height : 0;
                        if (ratio >= ratioThreshold) {
                            setActive(true);
                            return;
                        }
                        if (targetEl.classList.contains(activeClassName)) {
                            if (!removeOnlyOnScrollUp || (self && self.direction === -1)) {
                                setActive(false);
                            }
                        }
                    },
                    invalidateOnRefresh: true
                });
            })();
        }
    };

    setupDelayedVisibilityClass('#UT3_2026 .module5 .display-img-item1', '.pos-title', 0.1, 0, 'is-active', true);
    setupDelayedVisibilityClass('#UT3_2026 .module5 .display-img-item2', '.pos-title', 0.8, 0, 'is-active', true);
    setupDelayedVisibilityClass('#UT3_2026 .module5 .display-img-item3', '.pos-title', 0.9, 0, 'is-active', true);

    var ut3SwiperEl = document.querySelector('#ut3-swiper');
    if (ut3SwiperEl && window.Swiper) {
        if (ut3SwiperEl.swiper && ut3SwiperEl.swiper.destroy) {
            ut3SwiperEl.swiper.destroy(true, true);
        }

        var ut3SlideCount = ut3SwiperEl.querySelectorAll('.swiper-slide').length;
        var ut3Swiper = new Swiper('#ut3-swiper', {
            loop: ut3SlideCount > 1,
            loopAdditionalSlides: ut3SlideCount,
            slidesPerView: 'auto',
            spaceBetween: 24,
            watchOverflow: false,
            observer: true,
            observeParents: true,
            navigation: {
                prevEl: '#ut3-swiper .swiper-button-prev',
                nextEl: '#ut3-swiper .swiper-button-next'
            },
            on: {
                init: function () {
                    if (this.params.loop) {
                        this.loopDestroy();
                        this.loopCreate();
                        this.update();
                    }
                }
            }
        });

        var ut3SwiperImages = ut3SwiperEl.querySelectorAll('img');
        var rebuildUt3SwiperLoop = function () {
            if (!ut3Swiper) {
                return;
            }

            ut3Swiper.update();
            if (ut3Swiper.params && ut3Swiper.params.loop) {
                ut3Swiper.loopDestroy();
                ut3Swiper.loopCreate();
                ut3Swiper.update();
            }
        };

        for (var s = 0; s < ut3SwiperImages.length; s++) {
            ut3SwiperImages[s].addEventListener('load', rebuildUt3SwiperLoop);
        }

        if (ut3Swiper && ut3Swiper.on) {
            ut3Swiper.on('imagesReady', rebuildUt3SwiperLoop);
        }

        if (window.MutationObserver) {
            var ut3SwiperObserver = new MutationObserver(function (mutations) {
                for (var m = 0; m < mutations.length; m++) {
                    if (mutations[m].type === 'attributes' && mutations[m].attributeName === 'src') {
                        rebuildUt3SwiperLoop();
                        return;
                    }
                }
            });

            for (var n = 0; n < ut3SwiperImages.length; n++) {
                ut3SwiperObserver.observe(ut3SwiperImages[n], { attributes: true, attributeFilter: ['src'] });
            }
        }
    }

    window.addEventListener('load', function () {
        ScrollTrigger.refresh();
        setTimeout(function () {
            ScrollTrigger.refresh();
        }, 300);
    });
});
